/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { Epic } from 'redux-observable';
import { PortalWebsite } from '@api/model';
import history from 'src/js/constant/History';
import PortalWebsiteService from 'src/js/api/services/PortalWebsiteService';
import { Request, Create } from '../EpicUtils';
import {
  GET_PORTAL_WEBSITES,
  getPortalWebsiteFulfilled,
} from 'src/js/redux/actions/PortalWebsite';

const request: Request<PortalWebsite[], boolean> = {
  type: GET_PORTAL_WEBSITES,
  getData: () => PortalWebsiteService.getPortalPortalWebsites(),
  processData: (portals, state, navigate) => {
    if (navigate) {
      history.push(`/portals/${portals[portals.length-1].id}`)
    }
    return [
      getPortalWebsiteFulfilled(portals.map(p => ({
        ...p,
        logoPreview: p.websiteLogo
      })))
    ]
  }
};

export const EpicGetPortalWebsites: Epic<any, any> = Create(request);
